export default "__VITE_ASSET__CPY5irR3__"